import React from 'react';
import { useAuth } from '../authentication/AuthContext';
import '../styles/Footer.css';

function Footer() {
  const { firstName } = useAuth();

  return (
    <footer className="footer">
        {firstName && <p style={{margin: '5px'}}>Welcome, {firstName}!</p>}
        <div 
          className="footer-nav-row"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '1.5em',
            margin: '0 0',
            fontSize: '1em',
            flexWrap: 'wrap'
          }}
        >
          <a href="/legal/privacy_policy.html">Privacy Policy</a>
          
          <a href="/legal/terms_of_service.html">Terms of Service</a>
          
          <a href="/FAQ">FAQ</a>
          
          <a href="/careers">Careers</a>
        </div>
        <div
          className="footer-info-row"
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            fontSize: '0.6em',
            gap: '1.5em',
            marginTop: '2.5em',
            color: 'var(--light-grey)',
            flexWrap: 'wrap'
          }}
        >
          <span>&copy; 2025 InstantFlows B.V.</span>
          <span>KvK: 96160861</span>
          <span>All rights reserved</span>
          <span>Willem Hioolenstraat 3 | 3065LE | Rotterdam</span>
        </div>
        <style>
          {`
            @media (max-width: 720px) {
              .footer-nav-row {
                flex-direction: column !important;
                gap: 0.5em !important;
                text-align: center;
              }
              .footer-nav-row a, .footer-info-row span {
                margin: 0.2em 0;
              }
              
              .footer-info-row span {
                font-size: 0.5em !important;
              }
              
              
            }
          `}
        </style>
    </footer>
    
  );
}

export default Footer;